import ApiService from './ApiService';

class WorkflowAccModificationService {
  async prepareIndividualAcc(payload) {
    try {
      const response = await ApiService.call(
        '/secured/prepare_individual_account_modification',
        'POST',
        payload,
      );

      console.log(response);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async saveIndividualAcc(payload) {
    try {
      const response = await ApiService.call(
        '/secured/save_individual_account_modification',
        'POST',
        payload,
      );

      console.log(response);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async submitIndividualAcc(payload) {
    try {
      const response = await ApiService.call(
        '/secured/submit_individual_account_modification',
        'POST',
        payload,
      );

      console.log(response);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async approveIndividualAcc(payload) {
    try {
      const response = await ApiService.call(
        '/secured/approve_individual_account_modification',
        'POST',
        payload,
      );

      console.log(response);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async deleteAcc(payload) {
    try {
      const response = await ApiService.call(
        '/secured/delete_account_modification',
        'POST',
        payload,
      );

      console.log(response);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async getIndividualAcc(payload) {
    try {
      const response = await ApiService.call(
        '/secured/get_individual_account_modification',
        'POST',
        payload,
      );

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async getIndividualAccList(payload) {
    try {
      const response = await ApiService.call(
        '/secured/get_individual_account_modification_list',
        'POST',
        payload,
      );
      console.log(response.result);

      return {
        traderList: response.result.map(data => {
          return {
            workflowId: data.individualAccountModificationData.workflowId,
            applicationNo: data.applicationInfo.applicationNo,
            clientType: data.applicationInfo.clientType,
            tradingAccountNo: data.individualAccountModificationData.tradingAccountNo,
            primaryEmail: data.individualAccountModificationData.primaryEmail,
            firstName: data.individualProfile.firstName,
            lastName: data.individualProfile.lastName,
            middleName: data.individualProfile.middleName,
            nameOnIdentity: data.individualProfile.nameOnIdentity,
            identityValue: data.individualProfile.identityValue,
            identityType: data.individualProfile.identityType,
            traderId: data.individualAccountModificationData.workflowId,
            stage: data.individualAccountModificationData.workflowStage,
          };
        }),
        totalCount: response.totalCount,
        page: response.offset,
        size: response.size,
        success: true,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async prepareCorporateAcc(payload) {
    try {
      const response = await ApiService.call(
        '/secured/prepare_corporate_account_modification',
        'POST',
        payload,
      );

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async saveCorporateAcc(payload) {
    try {
      const response = await ApiService.call(
        '/secured/save_corporate_account_modification',
        'POST',
        payload,
      );

      console.log(response);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async submitCorporateAcc(payload) {
    try {
      const response = await ApiService.call(
        '/secured/submit_corporate_account_modification',
        'POST',
        payload,
      );

      console.log(response);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async approveCorporateAcc(payload) {
    try {
      const response = await ApiService.call(
        '/secured/approve_corporate_account_modification',
        'POST',
        payload,
      );

      console.log(response);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async getCorporateAcc(payload) {
    try {
      const response = await ApiService.call(
        '/secured/get_corporate_account_modification',
        'POST',
        payload,
      );

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async getCorporateAccList(payload) {
    try {
      const response = await ApiService.call(
        '/secured/get_corporate_account_modification_list',
        'POST',
        payload,
      );

      return {
        traderList: response.result.map(data => {
          return {
            workflowId: data.corporateAccountModificationData.workflowId,
            applicationNo: data.applicationInfo.applicationNo,
            clientType: data.applicationInfo.clientType,
            firmName: data.corporateProfile.firmName,
            registrationNo: data.corporateProfile.registrationNo,
            tradingAccountNo: data.corporateAccountModificationData.tradingAccountNo,
            primaryEmail: data.corporateAccountModificationData.primaryEmail,
            stage: data.corporateAccountModificationData.workflowStage,
            traderId: data.corporateAccountModificationData.workflowId,
          };
        }),
        totalCount: response.totalCount,
        page: response.offset,
        size: response.size,
        success: true,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async addCorporateDirector(payload) {
    try {
      const response = await ApiService.call('/secured/add_director_modification', 'POST', payload);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async modifyCorporateDirector(payload) {
    try {
      const response = await ApiService.call(
        '/secured/modify_director_modification',
        'POST',
        payload,
      );

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async addCorporateAuthorizedPerson(payload) {
    try {
      const response = await ApiService.call(
        '/secured/add_authorized_person_modification',
        'POST',
        payload,
      );

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async modifyCorporateAuthorizedPerson(payload) {
    try {
      const response = await ApiService.call(
        '/secured/modify_authorized_person_modification',
        'POST',
        payload,
      );

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async addCorporateCompanyOwner(payload) {
    try {
      const response = await ApiService.call(
        '/secured/add_company_owner_modification',
        'POST',
        payload,
      );

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async modifyCorporateCompanyOwner(payload) {
    try {
      const response = await ApiService.call(
        '/secured/modify_company_owner_modification',
        'POST',
        payload,
      );

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async removeCorporateDirector(payload) {
    try {
      const response = await ApiService.call(
        '/secured/remove_director_modification',
        'POST',
        payload,
      );

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async removeCorporateAuthPerson(payload) {
    try {
      const response = await ApiService.call(
        '/secured/remove_authorized_person_modification',
        'POST',
        payload,
      );

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async removeCorporateCompanyOwner(payload) {
    try {
      const response = await ApiService.call(
        '/secured/remove_company_owner_modification',
        'POST',
        payload,
      );

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async generateCorporateDocument(payload = {}) {
    try {
      const response = await ApiService.call(
        '/secured/upload_corporate_account_modification_document',
        'POST',
        payload,
      );
      let data = response;

      return {
        uploadUrl: data.uploadUrl,
        success: true,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async generateIndividualDocument(payload = {}) {
    try {
      const response = await ApiService.call(
        '/secured/upload_individual_account_modification_document',
        'POST',
        payload,
      );
      let data = response;

      return {
        uploadUrl: data.uploadUrl,
        success: true,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }
}
export default new WorkflowAccModificationService();
